import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowLeft, ArrowRight, Star } from "lucide-react";
import { TESTIMONIALS } from "@/data/content";

const FB_REVIEWS = "https://www.facebook.com/share/1D36HFTaeK/?mibextid=wwXIfr";

export const Testimonials = () => {
  const [i, setI] = useState(0);
  const next = () => setI((p) => (p + 1) % TESTIMONIALS.length);
  const prev = () => setI((p) => (p - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);

  useEffect(() => {
    const t = setInterval(next, 6000);
    return () => clearInterval(t);
  }, []);

  const t = TESTIMONIALS[i];

  return (
    <section id="testimonials" className="bg-blush-light py-24 md:py-32 overflow-hidden">
      <div className="max-w-[1100px] mx-auto px-6 md:px-12 text-center">
        <p className="text-xs uppercase tracking-[0.28em] text-cocoa mb-6">(Kind words)</p>
        <div className="flex flex-col items-center gap-3 mb-12">
          <div className="flex items-center gap-1.5" data-testid="testimonial-stars">
            {[...Array(5)].map((_, s) => (
              <Star key={s} size={22} className="fill-blush text-blush" />
            ))}
          </div>
          <p className="font-serif text-2xl md:text-3xl text-espresso">
            100% <span className="italic text-blush">recommend</span>
          </p>
        </div>

        <div className="min-h-[300px] md:min-h-[320px] flex items-center justify-center">
          <AnimatePresence mode="wait">
            <motion.blockquote
              key={i}
              data-testid="testimonial-quote"
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -24 }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            >
              <p className="font-serif font-light italic text-espresso text-2xl md:text-4xl leading-[1.2] tracking-tight max-w-3xl mx-auto">
                "{t.quote}"
              </p>
              <footer className="mt-8">
                <p className="font-serif text-2xl text-espresso">{t.name}</p>
                <p className="text-xs uppercase tracking-[0.22em] text-cocoa mt-1">{t.role}</p>
              </footer>
            </motion.blockquote>
          </AnimatePresence>
        </div>

        <div className="flex items-center justify-center gap-4 mt-12">
          <button data-testid="testimonial-prev" onClick={prev} className="h-12 w-12 rounded-full border border-espresso/30 flex items-center justify-center text-espresso hover:bg-espresso hover:text-cream transition-colors duration-300">
            <ArrowLeft size={18} />
          </button>
          <div className="flex gap-2">
            {TESTIMONIALS.map((_, idx) => (
              <button key={idx} onClick={() => setI(idx)} className={`h-1.5 transition-all duration-300 ${idx === i ? "w-8 bg-espresso" : "w-1.5 bg-espresso/30"}`} aria-label={`Go to testimonial ${idx + 1}`} />
            ))}
          </div>
          <button data-testid="testimonial-next" onClick={next} className="h-12 w-12 rounded-full border border-espresso/30 flex items-center justify-center text-espresso hover:bg-espresso hover:text-cream transition-colors duration-300">
            <ArrowRight size={18} />
          </button>
        </div>

        <a href={FB_REVIEWS} target="_blank" rel="noreferrer" data-testid="testimonial-fb-link" className="inline-block mt-10 text-xs uppercase tracking-[0.22em] text-cocoa hover:text-blush transition-colors duration-300 border-b border-cocoa/30 hover:border-blush pb-1">
          Read all reviews on Facebook
        </a>
      </div>
    </section>
  );
};
